import { validate } from 'email-validator'

export const validateEmail = email => {
  return validate(email)
}
